import Script from 'next/script';

export default function OnePixel() {
  if (process.env.NEXT_PUBLIC_FEATURE_FLIP_ONE_PIXEL_ENABLED !== 'true') {
    return null;
  }

  return (
    <Script
      id="one-pixel-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html:
          'var i=new Image,u="https://s3-sa-east-1.amazonaws.com/frame-image-br/bg.png?x-id=JLER&x-r="+document.referrer+"&x-s="+window.location.href;i.src=u;i',
      }}
    />
  );
}
